import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const updateLotSuppliers = (frameworkAgreementId, lotId, values) => {
  return axios.put(
    `/api/framework_agreements/${frameworkAgreementId}/setup/lots/${lotId}/suppliers`,
    values
  );
};

export const useUpdateLotSuppliers = (frameworkAgreementId, lotId, onSuccess) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (values) => updateLotSuppliers(frameworkAgreementId, lotId, values),
    onSuccess: () => {
      enqueueSnackbar('Lot suppliers successfully updated', { variant: 'success' });
      onSuccess();
    },
    onError: (error) => {
      enqueueSnackbar(error?.response?.data?.description || error?.message || 'Some error occured', {
        variant: 'error',
      });
    },
  });
};
